import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import { useTranslation } from 'react-i18next';
import { AAS_PREFIX } from "../../../global/constants";

export default function MicrosoftLoginForm() {
  const { t } = useTranslation();
  const [email, setEmail] = useState("");
  const navigate = useNavigate();

  const handleMicrosoftLogin = () => {
    if (!email || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      toast.error(t('microsoftLoginForm.messages.invalidEmail'));
      return;
    }

    window.location.href = `${AAS_PREFIX}/sso/redirect?email=${encodeURIComponent(email)}`;
  };

  return (
    <form onSubmit={(e) => e.preventDefault()} className="text-left">
      {/* Back to login */}
      <div className="mb-3">
        <button
          type="button"
          onClick={() => navigate("/login")}
          className="btn btn-link p-0 text-decoration-none"
          style={{
            color: "#9333ea",
            fontWeight: 500,
            fontSize: "0.95rem",
            display: "flex",
            alignItems: "center",
            gap: "0.4rem",
          }}
        >
          <i className="fa fa-chevron-left" />{t('microsoftLoginForm.backToLogin')} 
        </button>
      </div>

      {/* Email field */}
      <div className="form-group mb-4">
        <label htmlFor="email" className="fw-medium mb-1">{t('microsoftLoginForm.professionalEmail')}</label>
        <div
          className="input-group border rounded shadow-sm overflow-hidden transition"
          style={{ transition: "all 0.2s ease-in-out" }}
        >
          <span className="input-group-text bg-white border-0">
            <i className="fa fa-envelope" />
          </span>
          <input
            type="email"
            id="email"
            placeholder={t('microsoftLoginForm.emailPlaceholder')}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            className="form-control border-0"
            onFocus={(e) =>
              e.target.parentNode.style.boxShadow = "0 0 0 3px rgba(124, 58, 237, 0.25)"
            }
            onBlur={(e) =>
              e.target.parentNode.style.boxShadow = "none"
            }
          />
        </div>
      </div>

      {/* Submit button */}
      <button
        type="submit"
        className="btn w-100 py-2 fw-semibold text-white"
        onClick={handleMicrosoftLogin}
        style={{
          background: "linear-gradient(90deg, #7c3aed, #2563eb)",
          border: "none",
          borderRadius: "0.6rem",
          transition: "transform 0.2s ease-in-out",
        }}
        onMouseEnter={(e) => (e.currentTarget.style.transform = "translateY(-1px)")}
        onMouseLeave={(e) => (e.currentTarget.style.transform = "translateY(0)")}

      >
        {t('microsoftLoginForm.connectWithSSO')}
      </button>
    </form>
  );
}
